import { defineManifest } from "@tc/sdk";
import { LEARNING_TASKS } from "./tasks.js";
export const manifest = defineManifest({
    id: "learning",
    name: "eLearning",
    version: "0.1.0",
    tier: "addon",
    accent: "brand",
    description: "Training that runs on any phone: courses with pictures, video, characters and hands-on checks, quizzes and certificates, given to the right people at every site and kept up to date, with an AI builder that turns your own documents into a course.",
    permissions: {
        learn: "Take training: your courses, quizzes and certificates",
        team: "See how the team at your sites is getting on with their training",
        assign: "Give courses to people, sites, jobs or levels, set due dates, and reset attempts",
        build: "Make and change courses: the builder, AI build and review, characters, publishing",
        reports: "Training reports: completion, scores, question analysis, ratings and feedback",
    },
    grants: {
        "Head office": ["learn", "team", "assign", "build", "reports"],
        "Area manager": ["learn", "team", "assign", "reports"],
        "Site manager": ["learn", "team", "reports"],
        Supervisor: ["learn", "team"],
        Staff: ["learn"],
    },
    tasks: LEARNING_TASKS,
    widgets: [
        { key: "my-learning", title: "My training", description: "Courses you need to do, with due dates.", group: "People", size: 1, permission: "learn", defaultOn: true, order: 6 },
        { key: "team-training", title: "Team training", description: "Who at your sites is overdue or due soon.", group: "People", size: 1, permission: "team", defaultOn: true, order: 32 },
    ],
    nav: [
        { label: "My learning", path: "/learning", section: "people", tab: "Me", tabIcon: "user", permission: "learn", icon: "graduation", order: 9, blurb: "Your courses, quizzes and certificates" },
        { label: "Team training", path: "/learning/team", section: "people", tab: "Staff", permission: "team", icon: "users", order: 56, blurb: "How the team at your sites is getting on with training" },
        { label: "Course builder", path: "/learning/courses", section: "people", kind: "settings", permission: "build", icon: "book", order: 57, blurb: "Make, check and publish training courses" },
    ],
});
